// removed by extract-text-webpack-plugin
module.exports = {"container":"_3X-42bL9_o1raln0w9p1TY"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Settings/Layout/styles.css
// module id = 2643
// module chunks = 0